import classNames from "classnames";
import React from "react";
import "./UnreadMessagesIndicator.css";

type Properties = {
    type: "unread" | "overdue" | "overdue-soon" | "info";
    count: string | number | null | undefined;
    className?: string;
};

const UnreadMessagesIndicator = function UnreadMessagesIndicator(props: Properties) {
    const { type, count, className } = props;
    if (!count) return null;
    return (
        <span
            className={classNames(
                "unread-messages-indicator",
                `unread-messages-indicator--${type}`,
                className,
            )}
        >
            {count}
        </span>
    );
};

export default UnreadMessagesIndicator;
